import { render } from "./TicketReportDetail.vue?vue&type=template&id=29e699b1"
import script from "./TicketReportDetail.vue?vue&type=script&lang=ts"
export * from "./TicketReportDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script